import _ from 'lodash';
import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';
import {all} from 'redux-saga/effects';

import {
  fetchAllocations as fetchAllocationsAction,
  fetchAllocationStatistics as fetchAllocationStatisticsAction,
  deleteOfflinePeriod as deleteOfflinePeriodAction,
  fetchOfflinePeriodReasons as fetchOfflinePeriodReasonsAction,
  editOfflinePeriodStartDate as editOfflinePeriodStartDateAction,
  editOfflinePeriodEndDate as editOfflinePeriodEndDateAction,
  editOfflinePeriodReason as editOfflinePeriodReasonAction,
  createOfflinePeriod as createOfflinePeriodAction,
  changeCleaningStatus as changeCleaningStatusAction,
  fetchOfflinePeriod as fetchOfflinePeriodAction,
  editOfflinePeriodNotes as editOfflinePeriodNotesAction,
  fetchRoomHistory as fetchRoomHistoryAction,
  fetchRoomsForRoomPurposes as fetchRoomsForRoomPurposesAction,
  assignRoomPurpose as assignRoomPurposeAction,
  getChangesBeforeCreatingRoomPurposes as getChangesBeforeCreatingRoomPurposesAction,
  fetchRoomsForRoomPurposesWithoutFilters as fetchRoomsForRoomPurposesWithoutFiltersAction
} from './';

import {
  fetchAllocations,
  fetchAllocationStatistics,
  deleteOfflinePeriod,
  fetchOfflinePeriodReasons,
  createOfflinePeriod,
  changeRoomCleaningStatus,
  fetchOfflinePeriod,
  editOfflinePeriodStartDate,
  editOfflinePeriodEndDate,
  editOfflinePeriodReason,
  editOfflinePeriodNotes,
  fetchRoomHistory,
  fetchRoomsForRoomPurposes,
  assignRoomPurpose,
  getChangesBeforeCreatingRoomPurposes
} from 'sdk/allocations';

function* allocationsSaga() {
  yield all([
    createFetchSagaLatest(fetchAllocationsAction, fetchAllocations),
    createFetchSagaLatest(
      fetchAllocationStatisticsAction,
      fetchAllocationStatistics
    ),
    createPostSagaLatest(deleteOfflinePeriodAction, deleteOfflinePeriod),
    createFetchSagaLatest(
      fetchOfflinePeriodReasonsAction,
      fetchOfflinePeriodReasons
    ),
    createPostSagaLatest(
      editOfflinePeriodStartDateAction,
      editOfflinePeriodStartDate
    ),
    createPostSagaLatest(
      editOfflinePeriodEndDateAction,
      editOfflinePeriodEndDate
    ),
    createPostSagaLatest(
      editOfflinePeriodReasonAction,
      editOfflinePeriodReason
    ),
    createPostSagaLatest(editOfflinePeriodNotesAction, editOfflinePeriodNotes),
    createPostSagaLatest(createOfflinePeriodAction, createOfflinePeriod),
    createPostSagaLatest(changeCleaningStatusAction, changeRoomCleaningStatus),
    createFetchSagaLatest(fetchOfflinePeriodAction, fetchOfflinePeriod),
    createFetchSagaLatest(fetchRoomHistoryAction, fetchRoomHistory),
    createFetchSagaLatest(
      fetchRoomsForRoomPurposesAction,
      fetchRoomsForRoomPurposes
    ),
    createPostSagaLatest(assignRoomPurposeAction, assignRoomPurpose),
    createPostSagaLatest(
      getChangesBeforeCreatingRoomPurposesAction,
      getChangesBeforeCreatingRoomPurposes
    ),
    createFetchSagaLatest(
      fetchRoomsForRoomPurposesWithoutFiltersAction,
      fetchRoomsForRoomPurposes
    )
  ]);
}

export default allocationsSaga;
